
/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *    .       .       .       .       .       .       .       .       .       .       .       .
 *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *      ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *   . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *        .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *   .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 * Copyright FortyFix(c) 2024.
 * Title: Clienti.ts;
 * Path: /Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/GESFF_Gestionale_FF_Angular/src/environments/Modules/Clienti.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 06/02/25, 11:28;
 *
 *
 */

export var Fornitori = () => {

    var env = {
        Modules: {
            "Clienti": true,
            "Admin": true,
        },
        Menu: [
            {
                module: "Clienti",
                path: "/listautenti/aziende/f",
                title: 'menu.fornitori',
                icon: "mdi mdi-account-multiple",
                capacita: ["menu-clienti"]
            },
        ],
         ClientiAddOn: {
            codAdhoc: false,
            enable: false,
            info: true,
            commerciale: false,
            segnalatore: false,
            segnalatoreInterno: false,
            sedi: false,
            TipoSedePrimaria: false,
            attivita: false,
            geolocalizzazione: false,
            ruolo: true,
            Modifica: false,
            prodotti: false,
            rma: false,
            accesso: false,
            referenti: false,
            interventi: false,
            note_private: false,
            rating: false,
            ruoliAccesso: false,
            compilazione: false,
            luogoNascita: false,
            dataNascita: false,
            statoCivile: false,
            titoloStudio: false,
            occupazione: false,
            invalidita: false,
            legge104: false,
            diagnosi: false,
            accompagnamento: false,
            pensione: false,
            tutelare: false,
            medico: false,
            telMedico: false,
            terapia: false
        },
    };
    return env;
}